import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78990f72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row items-start justify-between no-wrap",
  style: {"width":"calc(100% - 30px - 20px)"}
}
const _hoisted_2 = { class: "row no-wrap" }
const _hoisted_3 = {
  class: "d-flex flex-column align-items-center",
  style: {"width":"calc(100% - 30px - 30px)"}
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center",
  style: {"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"}
}
const _hoisted_5 = {
  key: 0,
  src: "images/notifications/error.svg",
  alt: "Error",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_6 = {
  class: "mt-2 text-teal",
  style: {"font-size":"1.1em"}
}

import { ref, nextTick, Ref, computed, watch, onUnmounted, inject } from 'vue';

import SpinLoader from '@/App/Components/SpinLoader.vue';
import UiPopup from '@/ManualApp/Components/Popups/UiPopup.vue';
import SimpleTrackPlayer from '@/App/Components/Player/SimpleTrackPlayer.vue';
import ChartPopup from './ChartPopup.vue';

import {
  getPositionsFromOur,
  ITreatmentPositions,
} from '../getPositionsFromOur';
import { useTrackInfo } from '../trackInfo';
import { MapClass } from '@/Leaflet/MapClass';
import { wait } from '@/helpers/main_helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapPopup',
  props: {
  modelValue: Boolean,
  oid: [String, Number],
  name: String,
  from: Number,
  to: Number,
  gCategory: Number,
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props




const getFullDate = inject('getFullDate');

const MAP_ID = 'excavator-operation-map';
const POPUP_WIDTH = 80;

const map: Ref<MapClass | null> = ref(null);

const model = computed({
  get: () => props.modelValue,
  set: (show) => emit('update:modelValue', show),
});

const tracks: Ref<Map<any, any>> = ref(new Map());

const isRequest = ref(false);
const requestText = ref('');
const requestError = ref(false);

const trackKey = computed(() => `${props.oid}#${props.from}#${props.to}`);

watch(
  () => props.modelValue,
  async (show) => {
    if (show) {
      initMap();
      displayTrack();
    }
  },
);

onUnmounted(() => {
  tracks.value.clear();
});

const processCallback = (
  state: string,
  label: string,
  color?: string,
  percent?: number | string,
) => {
  requestText.value = label;
  isRequest.value = true;
  if (state === 'error') {
    requestError.value = true;
  }
};

async function displayTrack() {
  requestError.value = false;

  const { oid, from, to } = props;

  if (!oid || !from || !to) return;

  const key = trackKey.value;

  if (!tracks.value.has(key)) {
    const data = await requestTrack(oid, from, to);

    if (data && props.modelValue) {
      requestText.value = 'Данные загружены. Создание трека...';
      await wait(0);

      isRequest.value = false;
      drawTrack(data);
      tracks.value.set(key, data);
    }
  } else {
    const data = tracks.value.get(key);

    if (!data) {
      isRequest.value = true;
      requestError.value = true;
      requestText.value = 'Данные не найдены. Повторите запрос';
      tracks.value.delete(key);
      return;
    }

    requestText.value = 'Создание трека...';
    isRequest.value = true;

    await new Promise((r) => setTimeout(r, 1000));

    drawTrack(data);
    isRequest.value = false;
  }
}

async function requestTrack(oid: string | number, from: number, to: number) {
  if (!oid) return;

  return await getPositionsFromOur({
    objId: oid.toString(),
    processCallback,
    isOnMap: true,
    interval: { from, to },
  });
}

function drawTrack(data: ITreatmentPositions) {
  const { trackInfo } = useTrackInfo(data, new Date(), props.gCategory);
  map.value?.addPolylines(data.points, trackInfo, data.objId);
}

async function initMap() {
  await nextTick();
  map.value = new MapClass(MAP_ID);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(model))
      ? (_openBlock(), _createBlock(UiPopup, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = () => (model.value = false)),
          "style-for-body": "padding: 10px; width: 80vw; max-width: 100vw",
          "close-button": "",
          class: "my-popup"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (!isRequest.value)
                  ? (_openBlock(), _createBlock(SimpleTrackPlayer, {
                      key: 0,
                      "map-width": POPUP_WIDTH,
                      "treatment-positions": tracks.value.get(_unref(trackKey)),
                      map: map.value
                    }, null, 8, ["treatment-positions", "map"]))
                  : _createCommentVNode("", true),
                (!isRequest.value)
                  ? (_openBlock(), _createBlock(ChartPopup, {
                      key: 1,
                      name: props.name,
                      interval: { from: props.from || 0, to: props.to || 0 },
                      positions: tracks.value.get(_unref(trackKey)),
                      map: map.value
                    }, null, 8, ["name", "interval", "positions", "map"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, "Эксплуатация экскаватора " + _toDisplayString(props.name), 1),
                _createElementVNode("div", null, " за период с " + _toDisplayString(_unref(getFullDate)(Number(props.from) / 1000)) + " по " + _toDisplayString(_unref(getFullDate)(Number(props.to) / 1000)), 1)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: MAP_ID,
              style: _normalizeStyle({
          width: `calc(${POPUP_WIDTH}vw - 20px)`,
          height: `80vh`,
          visibility: isRequest.value ? 'hidden' : 'visible',
        })
            }, null, 4),
            (isRequest.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    (requestError.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                      : _createCommentVNode("", true),
                    (!requestError.value)
                      ? (_openBlock(), _createBlock(SpinLoader, {
                          key: 1,
                          width: 50,
                          height: 50
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(requestText.value), 1),
                  (requestError.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary mt-2",
                        onClick: displayTrack
                      }, " Повторить запрос "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})